/**
 * Resolves a blueprint name to the corresponding blueprint id from the
 * available list. Returns `null` when the name is falsy or not found
 * (e.g. blueprints haven't loaded yet — the value will update on
 * re-render once they do).
 */
export function resolveBlueprintName(
  name: string | null,
  availableBlueprints: { id: string; name: string }[],
): string | null {
  if (!name) return null;
  return availableBlueprints.find((bp) => bp.name === name)?.id ?? null;
}
